module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customerForm"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.header) + " ")]), _vm._v(" "), _c('el-form', {
    ref: "customerForm",
    staticStyle: {
      "margin-left": "15%",
      "margin-right": "15%",
      "text-align": "left"
    },
    attrs: {
      "label-position": "left",
      "model": _vm.customerForm,
      "rules": _vm.genRules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Customer Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.customerForm.name),
      callback: function($$v) {
        _vm.$set(_vm.customerForm, "name", $$v)
      },
      expression: "customerForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email",
      "prop": "email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.customerForm.email),
      callback: function($$v) {
        _vm.$set(_vm.customerForm, "email", $$v)
      },
      expression: "customerForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Address",
      "prop": "addr"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.customerForm.addr),
      callback: function($$v) {
        _vm.$set(_vm.customerForm, "addr", $$v)
      },
      expression: "customerForm.addr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Tel.",
      "prop": "tel"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.customerForm.tel),
      callback: function($$v) {
        _vm.$set(_vm.customerForm, "tel", $$v)
      },
      expression: "customerForm.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Description",
      "prop": "desc"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.customerForm.desc),
      callback: function($$v) {
        _vm.$set(_vm.customerForm, "desc", $$v)
      },
      expression: "customerForm.desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "plain": "",
      "loading": _vm.generating
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd71148","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerForm.vue
// module id = hMR0
// module chunks = 1